<div class="card mb-0">
  <div class="flex justify-between items-start mb-3">
    <div>
      <span class="block text-muted-color font-medium text-sm mb-2">Total Tasks</span>
      <div class="text-surface-900 dark:text-surface-0 font-bold text-2xl">{{ count() }}</div>
    </div>
    <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-lg" style="width: 2.25rem; height: 2.25rem">
      <i class="pi pi-check-circle text-blue-500 text-lg"></i>
    </div>
  </div>
  <div class="flex items-center text-xs">
    <i class="pi pi-arrow-up text-green-500 mr-1"></i>
    <span class="text-green-600 font-medium">+12%</span>
    <span class="text-muted-color ml-1">from last month</span>
  </div>
</div>
